// src/config/projects.js
export const projectsConfig = {
  // Project categories for organization
  categories: {
    webApps: 'Web Applications',
    tools: 'Developer Tools',
    experiments: 'Experiments',
    games: 'Games',
  },

  // Individual project configurations
  projects: [
    {
      id: 'polaroid-framer',
      title: 'Polaroid Framer',
      description:
        'Add retro polaroid frames to your photos with custom captions',
      category: 'webApps',
      status: 'live',
      technologies: ['React', 'HTML5 Canvas', 'Vite', 'Tailwind CSS'],

      // Deployment configuration
      deployment: {
        type: 'subdomain', // subdomain, path, external, embedded
        url: 'https://photo-framer.haseebkhan.ca',
        embedUrl: 'https://photo-framer.haseebkhan.ca?embedded=true', // for iframe
        repository: 'https://github.com/haseebk/polaroid-framer',
      },

      // Display configuration
      display: {
        thumbnail: '/images/projects/photo-framer-thumbnail.png',
        screenshots: [
          '/images/projects/polaroid-framer-1.jpg',
          '/images/projects/polaroid-framer-2.jpg',
        ],
        featured: true,
        launchType: 'subdomain', // subdomain, embedded, external
        showInPortfolio: true,
      },

      // Metadata
      createdDate: '2025-05-21',
      lastUpdated: '2025-05-22',
      version: '1.0.0',
    },

    {
      id: 'ai-tinerary',
      title: 'Trippler',
      description:
        'An AI-powered trip planning application that generates personalized itineraries',
      category: 'webApps',
      status: 'development',
      technologies: [
        'Next.js',
        'TypeScript',
        'Prisma',
        'OpenAI API',
        'NextAuth',
        'Tailwind CSS',
        'Google Maps API',
        'Radix UI',
      ],

      deployment: {
        type: 'external',
        url: 'https://trippler.ca',
        repository: 'https://github.com/haseebk/ai-tinerary',
      },

      display: {
        thumbnail: '/images/projects/trippler-thumbnail.png',
        featured: true,
        launchType: 'subdomain',
        showInPortfolio: true,
      },

      createdDate: '2025-01-22', // update with actual start date
      lastUpdated: '2025-01-22', // update with actual date
      version: '0.1.0',
    },
    {
      id: 'finberry',
      title: 'Finberry',
      description:
        'A simulated investing application built with real-time market data',
      category: 'webApps',
      status: 'development',
      technologies: [
        'React',
        'Node.js',
        'Express.js',
        'MongoDB',
        'TwelveData API',
        'Firebase',
      ],

      deployment: {
        type: 'external',
        url: 'https://finberry.ca',
        repository: '',
      },

      display: {
        thumbnail: '/images/projects/finberry-thumbnail.png',
        featured: false,
        launchType: 'external',
        showInPortfolio: true,
      },

      createdDate: '2022-09-22',
      lastUpdated: '2023-05-12',
      version: '1.0.0',
    },
    // {
    //   id: "code-snippet-manager",
    //   title: "Code Snippet Manager",
    //   description: "Organize and share your code snippets with syntax highlighting",
    //   category: "tools",
    //   status: "live",
    //   technologies: ["Next.js", "TypeScript", "Prisma", "Tailwind CSS"],

    //   deployment: {
    //     type: "embedded", // This one will be embedded in an iframe
    //     url: "https://snippets.haseebkhan.ca",
    //     embedUrl: "https://snippets.haseebkhan.ca?embedded=true",
    //     repository: "https://github.com/haseebk/code-snippet-manager"
    //   },

    //   display: {
    //     thumbnail: "/images/projects/snippets-thumb.jpg",
    //     featured: true,
    //     launchType: "embedded",
    //     showInPortfolio: true
    //   },

    //   createdDate: "2025-01-10",
    //   lastUpdated: "2025-01-18",
    //   version: "2.1.0"
    // }
  ],
}

// Helper functions
export const getProjectById = (id) => {
  return projectsConfig.projects.find((project) => project.id === id)
}

export const getProjectsByCategory = (category) => {
  return projectsConfig.projects.filter(
    (project) => project.category === category
  )
}

export const getFeaturedProjects = () => {
  return projectsConfig.projects.filter((project) => project.display.featured)
}

export const getLiveProjects = () => {
  return projectsConfig.projects.filter((project) => project.status === 'live')
}

export const getProjectsByTechnology = (tech) => {
  return projectsConfig.projects.filter((project) =>
    project.technologies.includes(tech)
  )
}
